import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import { validateEmail, simplyClick } from "../../helpers";
import LoaderEmail from "../LoaderEmail";
import "./Email.scss";
import {
  errorEventsEmail,
  ERROR_EMAIL_ALREADY_REGISTERED,
  domains,
  landingId,
} from "../../constants";
import cn from "classnames";

export const Email = ({ data, setData, nextStep }) => {
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");

  const value = data.email || "";

  const handleAddEmail = (e) => {
    setErrorEmail(null);

    setData({
      ...data,
      email: e.target.value,
    });
  };

  const handleAutocompleteClick = (domain) => {
    const emailWithDomain = value.split("@")[0] + domain;

    setData({
      ...data,
      email: emailWithDomain,
    });

    setErrorEmail(null);
  };

  const handlerSubmit = (e) => {
    e.preventDefault();

    setLoader(true);
    setLoaderTextMain("Verifying your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still verifying your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(value, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderTextMain("");
      setLoaderTextSub("");

      const { status, error } = result;

      if (!status) {
        setErrorEmail(error);
        if (error === ERROR_EMAIL_ALREADY_REGISTERED) {
          setData({ ...data, email: value });
        }
        if (errorEventsEmail[error]) {
          simplyClick(errorEventsEmail[error]);
        }

        return;
      }

      simplyClick("cl_lnd_st4_continue");
      nextStep();
    });
  };

  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderTextMain} textSub={loaderTextSub} />
      )}

      <form className="email__form" onSubmit={handlerSubmit}>
        <div className="global__title global__title-mobile">
          What is your email?
        </div>

        <div className="input__wrapper">
          <InputGlobal
            className={cn("input__global", { error: errorEmail })}
            placeholder="Enter your email"
            name="email"
            value={value}
            onChange={handleAddEmail}
            onFocus={() => simplyClick("cl_lnd_st4_type_email")}
          />

          {value.length > 0 && !value.includes("@") && (
            <div className="autocomplete__box">
              <ul className="autocomplete__box-list">
                {domains.map((domain, index) => (
                  <li
                    key={index}
                    className="autocomplete__box-list-item"
                    onClick={() => handleAutocompleteClick(domain)}
                  >
                    {value}
                    {domain}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {errorEmail && <p className="error-text">{errorEmail}</p>}
        {errorEmail === ERROR_EMAIL_ALREADY_REGISTERED && (
          <div className="extra-info">
            <p>
              <a
                href={`/login/?landing_id=${landingId}${
                  value ? `&email=${encodeURIComponent(value)}` : ""
                }`}
                id="login-link"
                onClick={() => simplyClick("cl_lnd_againemail_login")}
              >
                Log in
              </a>{" "}
              or use another email
            </p>
          </div>
        )}

        <ButtonSubmit text="Continue" />

        <div className="slider__box">
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step"></span>
        </div>
      </form>
    </>
  );
};
